export default __webpack_public_path__ + "b0ae716a4126d914aab80d89087a15ea.svg";